import { LayoutPartDict } from '@lessonup/pins-shared';

// If there are no entries, we need to normalize the layout parts to undefined, to not break memo.
export function normalizeLayoutParts(layoutParts?: LayoutPartDict) {
  return layoutParts && Object.keys(layoutParts).length ? layoutParts : undefined;
}
